import { IconMail, IconMessageCircle } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';

export const StateIndicatorWrapper = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconWrapper = styled.div<{ $isActive: boolean; }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  border-radius: 50%;

  transition: background-color 0.2s ease-in-out;

  background-color: ${({ $isActive }) => $isActive ? BRAND_COLORS.red : BRAND_COLORS.lightGray};
`;

const iconAttrs = ({ $isActive }: { $isActive: boolean; }) => ({
  size: 18,
  color: $isActive ? BRAND_COLORS.white : BRAND_COLORS.darkStroke,
});

const iconStyles = css`
  transition: stroke 0.2s ease-in-out;
`;

interface IconProps {
  $isActive: boolean;
}

export const ChatIcon = styled(IconMessageCircle)
  .attrs<IconProps>(iconAttrs)`
    ${iconStyles}
    transform: scaleX(-1);
`;

export const MailIcon = styled(IconMail)
  .attrs<IconProps>(iconAttrs)`
  ${iconStyles}
`;

export const Divider = styled.hr`
  border: none;
  margin: 0;

  width: 24px;
  height: 1.5px;
  background-color: ${BRAND_COLORS.red};
  flex-grow: 1;
`;
